import { COOKIE_DOMAIN, SSO_COOKIE } from "src/_config";

export function setSSOCookie(token: string): void {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
  const domainStr = COOKIE_DOMAIN ? `; domain=${COOKIE_DOMAIN}` : "";
  document.cookie = `${SSO_COOKIE}=${token}; path=/${domainStr}; expires=${expires}; SameSite=Lax${secure}`;
}

export function getSSOCookie(): string | null {
  const name = SSO_COOKIE + "=";
  const parts = decodeURIComponent(document.cookie).split(";");
  for (const part of parts) {
    const c = part.trim();
    if (c.startsWith(name)) return c.substring(name.length);
  }
  return null;
}

export function clearSSOCookie(): void {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  const domainStr = COOKIE_DOMAIN ? `; domain=${COOKIE_DOMAIN}` : "";
  document.cookie = `${SSO_COOKIE}=; path=/${domainStr}; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax${secure}`;
}
